import { supabase } from "@/integrations/supabase/client";

export type PasswordResetEventType =
  | "requested"
  | "link_clicked"
  | "link_invalid"
  | "otp_submitted"
  | "completed";

interface LogParams {
  event_type: PasswordResetEventType;
  email?: string;
  error_code?: string;
  method?: "link" | "otp";
  metadata?: Record<string, unknown>;
}

async function sha256Hex(input: string): Promise<string> {
  const buf = new TextEncoder().encode(input);
  const hash = await crypto.subtle.digest("SHA-256", buf);
  return Array.from(new Uint8Array(hash))
    .map((b) => b.toString(16).padStart(2, "0"))
    .join("");
}

/**
 * Log een event in de password_reset_events tabel.
 * Slaat alleen e-maildomein + sha256 hash op (geen persoonsgegevens).
 */
export async function logPasswordResetEvent(params: LogParams): Promise<void> {
  try {
    const email = params.email?.trim().toLowerCase();
    const email_domain = email ? email.split("@")[1] : null;
    const email_hash = email ? await sha256Hex(email) : null;

    await supabase.from("password_reset_events").insert([
      {
        event_type: params.event_type,
        email_hash: email_hash ?? undefined,
        email_domain: email_domain ?? undefined,
        user_agent: typeof navigator !== "undefined" ? navigator.userAgent : undefined,
        error_code: params.error_code ?? undefined,
        method: params.method ?? undefined,
        metadata: (params.metadata as any) ?? {},
      },
    ]);
  } catch (e) {
    // Telemetrie mag nooit de UX breken
    console.warn("Failed to log password reset event:", e);
  }
}
